<i nz-icon nzType="plus"></i>

<input
  #fileInput
  hidden
  type="file"
  multiple
  accept="image/*"
  (change)="addUploadingItems($event)"
/>
